import { useTranslation } from 'react-i18next';
import { Layout } from '@/components/layout/Layout';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Pickaxe, Factory, Truck, Shield, ExternalLink } from 'lucide-react';

const pillars = [
  { key: 'minerals', icon: Pickaxe, color: 'bg-spa-minerals/10 text-spa-minerals' },
  { key: 'industrialization', icon: Factory, color: 'bg-spa-industrialization/10 text-spa-industrialization' },
  { key: 'infrastructure', icon: Truck, color: 'bg-spa-infrastructure/10 text-spa-infrastructure' },
  { key: 'governance', icon: Shield, color: 'bg-spa-governance/10 text-spa-governance' },
];

export default function AboutSPA() {
  const { t } = useTranslation();

  return (
    <Layout>
      <div className="container max-w-4xl py-12">
        <h1 className="mb-8 text-4xl font-bold">{t('aboutSpa.title')}</h1>

        <section className="mb-12">
          <h2 className="mb-4 text-2xl font-semibold">{t('aboutSpa.overview.title')}</h2>
          <p className="text-lg text-muted-foreground">{t('aboutSpa.overview.content')}</p>
        </section>

        <section className="mb-12">
          <h2 className="mb-6 text-2xl font-semibold">{t('aboutSpa.pillars.title')}</h2>
          <div className="grid gap-6 md:grid-cols-2">
            {pillars.map(({ key, icon: Icon, color }) => (
              <Card key={key}>
                <CardContent className="flex items-start gap-4 p-6">
                  <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${color}`}>
                    <Icon className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="mb-1 font-semibold">{t(`aboutSpa.pillars.${key}.title`)}</h3>
                    <p className="text-sm text-muted-foreground">{t(`aboutSpa.pillars.${key}.description`)}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>

        <section className="mb-12">
          <h2 className="mb-4 text-2xl font-semibold">{t('aboutSpa.howWeHelp.title')}</h2>
          <p className="text-lg text-muted-foreground">{t('aboutSpa.howWeHelp.content')}</p>
        </section>

        <Button asChild variant="outline" className="gap-2">
          <a href="https://www.state.gov" target="_blank" rel="noopener noreferrer">
            {t('aboutSpa.learnMore')}
            <ExternalLink className="h-4 w-4" />
          </a>
        </Button>
      </div>
    </Layout>
  );
}